import React from 'react';
import { Modal, Button, ListGroup, Badge } from 'react-bootstrap';
import MembroBanca from '../../../../model/banca/MembroBanca';

interface ModalSelecionarPresidenteProps {
    show: boolean;
    membros: MembroBanca[];
    presidenteId: string | null;
    onSelect: (membroId: string) => void;
    onConfirm: () => void;
    onCancel: () => void;
}

const ModalSelecionarPresidente: React.FC<ModalSelecionarPresidenteProps> = ({
    show,
    membros,
    presidenteId,
    onSelect,
    onConfirm,
    onCancel
}) => {
    const membrosTitulares = membros.filter(m => m.papelMembro.nome === 'Titular');

    return (
        <Modal show={show} onHide={onCancel} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Selecionar Presidente da Banca</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-3">
                    Selecione um membro titular para ser o presidente desta banca. 
                    {membrosTitulares.some(m => m.pessoa.vinculo.nome === 'Docente') && 
                        ' O Docente Titular foi pré-selecionado por padrão.'}
                </p>
                <ListGroup>
                    {membrosTitulares.map(membro => {
                        const isSelected = membro.id === presidenteId;
                        return (
                            <ListGroup.Item
                                key={membro.id}
                                action
                                onClick={() => onSelect(membro.id!)}
                                className={`d-flex justify-content-between align-items-center ${isSelected ? 'border-primary border-3 bg-primary bg-opacity-10' : ''}`}
                                style={{ 
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <div 
                                        className={`rounded-circle d-flex align-items-center justify-content-center ${isSelected ? 'bg-primary' : 'border border-2'}`}
                                        style={{ 
                                            width: '24px', 
                                            height: '24px',
                                            minWidth: '24px'
                                        }}
                                    >
                                        {isSelected && (
                                            <i className="bi bi-check text-white fw-bold" />
                                        )}
                                    </div>
                                    <div>
                                        <div className="fw-semibold d-flex align-items-center gap-2">
                                            {membro.pessoa.nome}
                                            {isSelected && (
                                                <Badge bg="primary">Presidente</Badge>
                                            )}
                                        </div>
                                        <small className="text-muted">
                                            {membro.papelMembro.nome} · {membro.pessoa.vinculo.nome}
                                            {membro.pessoa.matricula && ` · ${membro.pessoa.matricula}`}
                                        </small>
                                    </div>
                                </div>
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Cancelar
                </Button>
                <Button 
                    variant="primary" 
                    onClick={onConfirm}
                    disabled={!presidenteId}
                >
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalSelecionarPresidente;
